"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var selectors_1 = require("./selectors");
var actions_1 = require("./actions");
function withConfirm(PassedComponent) {
    var WrappedComponent = /** @class */ (function (_super) {
        __extends(WrappedComponent, _super);
        function WrappedComponent() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.destroyTimeout = 0;
            return _this;
        }
        WrappedComponent.prototype.componentWillReceiveProps = function (nextProps) {
            var _this = this;
            if (!this.props.willBeDestroyed && nextProps.willBeDestroyed) {
                this.destroyTimeout = window.setTimeout(function () { return _this.props.destroy(); }, 1000);
            }
            if (!this.props.isOpen && nextProps.isOpen) {
                window.clearTimeout(this.destroyTimeout);
            }
        };
        WrappedComponent.prototype.render = function () {
            return this.props.isOpen || this.props.willBeDestroyed ? (React.createElement(PassedComponent, __assign({}, this.props))) : null;
        };
        return WrappedComponent;
    }(React.Component));
    var mapStateToProps = function (state) {
        return selectors_1.selectConfirmModalState(state);
    };
    var mapDispatchToProps = function (dispatch) {
        return {
            hide: function () { return dispatch(actions_1.ConfirmActions.hide()); },
            destroy: function () { return dispatch(actions_1.ConfirmActions.destroy()); }
        };
    };
    var mergeProps = function (fields, actions, ownProps) {
        return __assign({}, ownProps, fields, actions, { onCancel: function () {
                fields.onCancel();
                actions.hide();
            }, onConfirm: function () {
                fields.onConfirm();
                actions.hide();
            } });
    };
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps, mergeProps)(WrappedComponent);
}
exports.withConfirm = withConfirm;
